import Logo from "./Logo"
import MainNavigation from "./MainNavigation"
import User from "./User"
import "./Navbar.css"

export default function Navbar() {
    return (
        <div className="navbar">
            <Logo />
            <MainNavigation />
            <User />
        </div>
    )
}